import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = 'rooneys_admin_token';

export const waitlistAPI = {
  // Public - Join waitlist
  join: async (data) => {
    const response = await axios.post(`${API}/waitlist`, data);
    return response.data;
  },

  // Public - Get summary of all barbers' queues
  getPublicSummary: async () => {
    const response = await axios.get(`${API}/waitlist/public`);
    return response.data;
  },

  // Public - Get details for a specific barber's queue
  getPublicByBarber: async (barber) => {
    const response = await axios.get(`${API}/waitlist/public`, {
      params: { barber },
    });
    return response.data;
  },

  // Public - Get status for a single entry (customer's own status page)
  getMyStatus: async (entryId) => {
    const response = await axios.get(`${API}/waitlist/status/${entryId}`);
    return response.data;
  },

  // Public - Customer updates their note to the shop
  updateMessage: async (entryId, message) => {
    const response = await axios.patch(`${API}/waitlist/${entryId}/message`, { message });
    return response.data;
  },

  // Public - Customer removes themselves from the waitlist
  leave: async (entryId) => {
    const response = await axios.delete(`${API}/waitlist/${entryId}`);
    return response.data;
  },
};

export const adminAPI = {
  // Login - sets token in localStorage
  login: async (password) => {
    const response = await axios.post(`${API}/admin/login`, { password });
    if (response.data.success) {
      localStorage.setItem(ADMIN_TOKEN_KEY, response.data.token);
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
  },

  isAuthenticated: () => {
    return !!localStorage.getItem(ADMIN_TOKEN_KEY);
  },

  getToken: () => {
    return localStorage.getItem(ADMIN_TOKEN_KEY);
  },

  // Get current waitlist
  getWaitlist: async () => {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    const response = await axios.get(`${API}/admin/waitlist`, {
      headers: { 'X-Admin-Password': token },
    });
    return response.data;
  },

  // Mark customer as served
  markServed: async (entryId) => {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    const response = await axios.patch(
      `${API}/admin/waitlist/${entryId}/serve`,
      {},
      { headers: { 'X-Admin-Password': token } }
    );
    return response.data;
  },

  // Move a customer up or down in their barber's queue
  moveEntry: async (entryId, direction) => {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    const response = await axios.patch(
      `${API}/admin/waitlist/${entryId}/move`,
      {},
      {
        headers: { 'X-Admin-Password': token },
        params: { direction },
      }
    );
    return response.data;
  },
};
